import _ from 'lodash';
import { colorVars, ColorNames, blendedColorVars, } from '../constants/colorVars';
import { lightenColor } from './lightenColor';
const colorLongToShort = (colorName) => _.camelCase(colorName.substring(8));
const colorShortToLong = (colorName) => _.camelCase(`utkColor${_.startCase(colorName)}`);
const getCssColorFromColorName = (colorName) => {
    const key = colorShortToLong(colorName);
    if (key in colorVars) {
        return colorVars[key];
    }
    if (key in blendedColorVars) {
        return blendedColorVars[key];
    }
    return '';
};
const INHERIT = 'inherit';
const colorOptions = _.keys(colorVars).map(colorLongToShort);
const blendedColorOptions = _.keys(blendedColorVars).map(colorLongToShort);
export { ColorNames, colorVars, colorLongToShort, colorShortToLong, getCssColorFromColorName, INHERIT, lightenColor, colorOptions, blendedColorOptions, };
//# sourceMappingURL=colors.js.map